import type { Branded } from "@@/utilities/branded";

type PubSubPushVerificationErrorMessage = Branded<
    string,
    "verification_error_message"
>;
class PubSubPushVerificationError extends Error {
    constructor(public errorMessages: PubSubPushVerificationErrorMessage[]) {
        super("verification of parsed pubsub message failed");
    }
}

export { PubSubPushVerificationError };
export type { PubSubPushVerificationErrorMessage };
